import { render, staticRenderFns } from "./CallTable.vue?vue&type=template&id=4f4398b6"
import script from "./CallTable.vue?vue&type=script&lang=js"
export * from "./CallTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports